export enum E_ChangeAction {
  Add = "add",
  Update = "update",
  Delete = "delete",
  AddBulk = "add-bulk",
  UpdateBulk = "update-bulk",
  DeleteBulk = "delete-bulk",
  Reset = "reset",
  Setup = 'setup',
}
